/**
 * @generated SignedSource<<d3f6f670905486e99f04ffe368a2cfc7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SelectClientsDialog_clients$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly displayName: string | null | undefined;
      readonly email: string | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "SelectClientsDialog_clients";
};
export type SelectClientsDialog_clients$key = {
  readonly " $data"?: SelectClientsDialog_clients$data;
  readonly " $fragmentSpreads": FragmentRefs<"SelectClientsDialog_clients">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SelectClientsDialog_clients",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ClientEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ClientConnection",
  "abstractKey": null
};

(node as any).hash = "1080d60599f49747c829c281ce9d91de";

export default node;
